import { useState } from 'react';

import Button, { ButtonProps } from '../../../../react-components/Button';
import { CreatePlanModal } from './CreatePlanModal';

type CreatePlanProps = {
  selectedDay?: Date;
  buttonProps: ButtonProps;
  handleAfterCreatePlan: (newPlanId: string, executionDate: Date) => void;
};

export const CreatePlan = ({ selectedDay, buttonProps, handleAfterCreatePlan }: CreatePlanProps) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        {...buttonProps}
        onClick={() => {
          setDialogOpen(true);
        }}
        intlId="planner.plans.create_new_plan"
      />
      {dialogOpen && (
        <CreatePlanModal
          open={dialogOpen}
          selectedDay={selectedDay}
          onCloseDialog={() => {
            setDialogOpen(false);
          }}
          handleAfterCreatePlan={(newPlanId: string, executionDate: Date) => {
            handleAfterCreatePlan(newPlanId, executionDate);
            setDialogOpen(false);
          }}
        />
      )}
    </>
  );
};
